import { render, staticRenderFns } from "./business-report.vue?vue&type=template&id=df04891c&scoped=true&"
import script from "./business-report.vue?vue&type=script&lang=js&"
export * from "./business-report.vue?vue&type=script&lang=js&"
import style0 from "./business-report.vue?vue&type=style&index=0&id=df04891c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df04891c",
  null
  
)

export default component.exports